/** 연결/별도 전환 — IXD 값 편집기 상단 바와 같은 모양·동작. 문서에 없는 유형은 자리를 남기고 잠근다. */

import type { FsType, IXDPreviewResponse } from "@/apis/ixd-editor/types";
import {
  ViewSwitchGroup,
  type ViewSwitchOption,
} from "@/toggle-ui-kit/view-switch-group";

const FS_TYPE_OPTIONS: ViewSwitchOption<FsType>[] = [
  { value: "consolidated", label: "연결" },
  { value: "separate", label: "별도" },
];

const NOT_AUTHORED_TOOLTIP: Record<FsType, string> = {
  consolidated: "이 문서는 연결을 작성하지 않았습니다",
  separate: "이 문서는 별도를 작성하지 않았습니다",
};

export const chunksOf = (preview: IXDPreviewResponse, fsType: FsType) =>
  fsType === "consolidated"
    ? preview.consolidatedChunks
    : preview.separateChunks;

export const FsTypeSwitch = ({
  value,
  availableFsTypes,
  onChange,
}: {
  value: FsType;
  availableFsTypes: FsType[];
  onChange: (fsType: FsType) => void;
}) => (
  <ViewSwitchGroup<FsType>
    options={FS_TYPE_OPTIONS.map((option) =>
      availableFsTypes.includes(option.value)
        ? option
        : {
            ...option,
            disabled: true,
            tooltip: NOT_AUTHORED_TOOLTIP[option.value],
          },
    )}
    value={value}
    onChange={onChange}
    size="28px"
  />
);
